import apiClient from "../../axios/apiClient";


export const getDashboardList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_DASHBOARD_PENDING" });

      const response = await apiClient.get(
        `/api/v1/dashboard`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_DASHBOARD_FULFILLED",
        payload: response.data,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      dispatch({
        type: "GET_DASHBOARD_REJECTED",
        payload: error.response,
      });
    }
  };

